import React, { Component } from 'react';
import Pikaday from 'pikaday';
import PropTypes from 'prop-types';

class ReactPikaday extends Component {

	componentDidMount() {
		let el = this.refs.pikaday;

		this._picker = new Pikaday({
			field: el,
			firstDay: 1,
			onSelect: this.getValueLink(this.props).requestChange,
			...this.props.initialOptions
		});

		this.setDateIfChanged(this.getValueLink(this.props).value);

		this.props.setPickerInstance(this._picker);
	}

	componentWillReceiveProps(nextProps) {
		let newDate = this.getValueLink(nextProps).value;
		let lastDate = this.getValueLink(this.props).value;

		this.setDateIfChanged(newDate, lastDate);
	}

	getValueLink = (props) => {
		return props.valueLink || {
				value: props.value,
				requestChange: props.onChange
			};
	};

	setDateIfChanged = (newDate, prevDate) => {
		let newTime = newDate ? newDate.getTime() : null;
		let prevTime = prevDate ? prevDate.getTime() : null;

		if ( newTime !== prevTime ) {
			if ( newDate === null ) {
				// Workaround for pikaday not clearing value when date set to falsey
				this.refs.pikaday.value = '';
			}
			this._picker.setDate(newDate, true);  // 2nd param = don't call onSelect
		}
	};

	// user props to pass down to the underlying DOM node
	getDomProps = () => {
		let restProps = {};
		for (let propKey in this.props) {
			if (this.props.hasOwnProperty(propKey) && !ReactPikaday.propTypes[propKey]) {
				restProps[propKey] = this.props[propKey];
			}
		}
		return restProps
	};

	render() {
		return (
			<input type="text" ref="pikaday" {...this.getDomProps()} />
		);
	}
}

ReactPikaday.propTypes = {
	value: PropTypes.instanceOf(Date),
	onChange: PropTypes.func,
	initialOptions: PropTypes.object,
	setPickerInstance: PropTypes.func,

	valueLink: PropTypes.shape({
		value: PropTypes.instanceOf(Date),
		requestChange: PropTypes.func.isRequired
	})
};

ReactPikaday.defaultProps = {
	initialOptions: {}
};

export default ReactPikaday;



// WEBPACK FOOTER //
// ./src/components/Pikaday.jsx